import { Box } from '@mui/material';
import { Link, useLocation } from 'react-router';
import { useState } from 'react';
import { menuItems } from '../../config/menuItems.tsx';
import Logo from '../../assets/logo.jpg';
import '../../styles/scss/Sidebar.scss';

export default function Sidebar() {
  const location = useLocation();
  const [expandedItems, setExpandedItems] = useState<Record<string, boolean>>({});

  const toggleExpand = (text: string) => {
    setExpandedItems(prev => ({
      ...prev,
      [text]: !prev[text]
    }));
  };

  const isActive = (path?: string) => {
    if (!path) return false;
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const isParentActive = (children?: Array<{ path?: string }>) =>
    children?.some((child) => {
      if (!child.path) return false;
      return location.pathname === child.path || location.pathname.startsWith(child.path + '/');
    });

  const renderNavItem = (item: typeof menuItems[0], isChild = false) => {
    if (item.children) {
      const isExpanded = expandedItems[item.text] || isParentActive(item.children);
      return (
        <Box key={item.text} className="nav-item-group">
          <button
            className={`nav-item-toggle ${isExpanded ? 'expanded' : ''}`}
            onClick={() => toggleExpand(item.text)}
          >
            <Box className="nav-item-left">
              {item.icon}
              <span className="nav-text">{item.text}</span>
            </Box>
            <span className="material-symbols-outlined expand-icon">expand_more</span>
          </button>
          <Box className="nav-children" style={{ display: isExpanded ? 'flex' : 'none' }}>
            {item.children.map((child) => (
              <Link
                key={child.text}
                to={child.path!}
                className={`nav-child ${isActive(child.path) ? 'active' : ''}`}
              >
                {child.icon && <span className="material-symbols-outlined">{child.icon.props.children}</span>}
                {child.text}
              </Link>
            ))}
          </Box>
        </Box>
      );
    }

    return (
      <Link
        key={item.text}
        to={item.path!}
        className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
      >
        {item.icon}
        <span className="nav-text">{item.text}</span>
      </Link>
    );
  };

  return (
    <Box component="aside" className="sidebar">
      <Box className="sidebar-header">
        <Box className="sidebar-logo">
          {/* <img src={Logo} alt="Tokyo Car Wash" /> */}
        </Box>
      </Box>

      <nav className="sidebar-nav">
        <Box className="nav-section">
          {menuItems.map((item) => renderNavItem(item))}
        </Box>
      </nav>

      <Box className="sidebar-footer">
        {/* <Box className="sidebar-stats">
          <Box className="stat-item">
            <p>156</p>
            <p>Products</p>
          </Box>
          <Box className="stat-item">
            <p>48</p>
            <p>Orders</p>
          </Box>
        </Box> */}
        
        <Box className="sidebar-links">
          {/* <Link to="#">
            <span className="material-symbols-outlined">help</span>
            Help & Support
          </Link> */}
          <Link to="/" className="logout">
            <span className="material-symbols-outlined">logout</span>
            Sign Out
          </Link>
        </Box>
      </Box>
    </Box>
  );
}
